import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { SectionTitleWithInfo } from "../../SectionTitleWithInfo";

/**
 * Layout component with Material UI integration
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The title to display
 * @param {string} props.subtitle - The subtitle to display
 * @param {React.ReactNode} props.children - The child components
 * @param {Object} props.style - Custom styles to apply to the container
 * @returns {React.ReactElement} Layout component
 */
export const Layout = ({ title, subtitle, children, style }) => {
  return (
    <Box
      sx={{
        maxWidth: "744px",
        margin: "0 auto",
        paddingBottom: 10,
        ...style
      }}
    >
      {title && <SectionTitleWithInfo title={title} info={subtitle} />}
      {children}
    </Box>
  );
};

Layout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object
};
